/*
 * This file is generated. Do not modify manually
 * @generated SignedSource<<54e333e22cd320bb1492e15e881079d4>>
 * @codegen-command: yarn dev generate:jira-spa-entry
 */
/* eslint-disable jira/filename-case */

import '@jira/platform__vendor/src/vendor-parcel.tsx';
import '@jira/platform__vendor/src/commons-parcel.tsx';

import { getSpaRoutes } from '@jira/platform__routes/src/getSpaRoutes.tsx';
import { setMark } from '@atlassian/jira-common-performance/src/marks.tsx';

import { startJiraSpa } from './start-jira-spa.tsx';

setMark('JIRA_SPA_ENTRY_LOADED');

startJiraSpa(getSpaRoutes);
